import styled from '@emotion/styled';

import { InfoHeading } from '../ResidentCard.styled';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: flex-start;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: flex-start;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: flex-start;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    align-items: flex-end;
  }
`;

export const CommentHeading = styled(InfoHeading)`
  margin: ${({ theme }) => theme.spacing([4, 0, 1])};
`;

export const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  em {
    ${({ theme }) => theme.text.body2};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;
